{
  "longPressMessage": "Ilgai paspauskite, kad atvertumėte peržiūrą"
}
